module.exports = __webpack_public_path__ + "img/939001655_1.01a75017.jpg";